import { render, staticRenderFns } from "./EventsTable.vue?vue&type=template&id=6ae4db3e&scoped=true&"
import script from "./EventsTable.vue?vue&type=script&lang=js&"
export * from "./EventsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae4db3e",
  null
  
)

export default component.exports